module["exports"] = [
  "Noord",
  "Oost",
  "West",
  "Zuid",
  "Nieuw",
  "Oud"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/city_prefix.js
// module id = 1163
// module chunks = 0